import { render, staticRenderFns } from "./BookNow.vue?vue&type=template&id=da1c2984&scoped=true&"
import script from "./BookNow.vue?vue&type=script&lang=js&"
export * from "./BookNow.vue?vue&type=script&lang=js&"
import style0 from "./BookNow.vue?vue&type=style&index=0&id=da1c2984&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1c2984",
  null
  
)

export default component.exports